import React from "react";
import { Button, Header, Icon, Modal } from "semantic-ui-react";
import { UserClaims } from "../../../../types/users";

type CancelInviteModalProps = {
  user: UserClaims | Record<string, never>;
  onCancelInvite: () => void;
  onClose: () => void;
};

const CancelInviteModal = (props: CancelInviteModalProps) => {
  const { user, onCancelInvite, onClose } = props;

  const handleCancelInvite = () => {
    onCancelInvite();
    onClose();
  };
  return (
    <Modal onClose={onClose} open={true} size="mini">
      <Header icon="trash" content={`Cancel invitation`} />
      <Modal.Content>
        <p>
          Are you sure you want to <b>cancel</b> the invitation to <b>{user.email}</b>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={onClose}>
          <Icon name="remove" /> No
        </Button>
        <Button color="green" onClick={handleCancelInvite}>
          <Icon name="checkmark" /> Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default CancelInviteModal;
